import { Button, Tabs } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import FiltersForm from '../../components/FiltersForm/FiltersForm';
import Icon from '../../components/Icon/Icon';
import SearchForm from '../../components/SearchForm/SearchForm';
import Survey from './Survey/Survey';
import styles from './BackofficeSurveys.module.scss';
import { useBackofficeSurveys } from './useBackofficeSurveys';
import CreateSurvey from "../../components/CreateSurvey/CreateSurvey";

const BackofficeSurveys = () => {
	const { TabPane } = Tabs;
	
	const {
		filterDefaultValues,
		filterFields,
		onResetFilters,
		onSubmitFilters,
		state,
		toggleCreateSurveyPopup,
		toggleMobileFilters,
	} = useBackofficeSurveys();
	const { activeFilters, showCreateSurvey, showMobileFilters } = state;
	
	const tabBarExtraContent = (
		<div className={styles.tabBarExtraContent}>
			<Button type="primary" size="large" onClick={toggleCreateSurveyPopup}>
				<FormattedMessage id="buttons.createSurvey" />
			</Button>
		</div>
	);

	return <div className={styles.pageContainer}>
		<div className={`${styles.pageSider} ${styles.topBorder}`}>
			<FiltersForm
				fields={filterFields}
				defaultValues={filterDefaultValues}
				onResetFilters={onResetFilters}
				onSubmit={(filters) => onSubmitFilters(filters)} />
		</div>
		<div className={styles.pageContent}>
			<div className={styles.mobileTopper}>
				<Button type="text" onClick={toggleMobileFilters} icon={<Icon color="black" name="sliders-h" />} />
			</div>
			<Tabs
				className={`navigator ${styles.content}`}
				defaultActiveKey="1"
				tabBarExtraContent={tabBarExtraContent}
			>
				<TabPane
					key="1"
					tab={<>
						<FormattedMessage id="navigation.survey" />
					</>}
				>
					<Survey filters={activeFilters} />
				</TabPane>
			</Tabs>
		</div>
		{showCreateSurvey && <CreateSurvey onClose={() => onResetFilters(toggleCreateSurveyPopup)} />}

		{/* Mobile filters */}
		<div className={`${styles.mobileFiltersBackdrop} ${showMobileFilters ? styles.open : ''}`}></div>
		<div className={`${styles.mobileFilters} ${showMobileFilters ? styles.open : ''}`}>
			<div className={styles.actions}>
				<Button onClick={toggleMobileFilters} type="link" style={{ paddingRight: 0 }}>
					<Icon
						color="text"
						height="16px"
						name="times"
						width="16px"
					/>
				</Button>
			</div>
			<FiltersForm
				fields={filterFields}
				defaultValues={filterDefaultValues}
				onResetFilters={() => onResetFilters(toggleMobileFilters)}
				onSubmit={(filters) => onSubmitFilters(filters, toggleMobileFilters)} />
		</div>
	</div>
};
export default BackofficeSurveys;